import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import _ from 'lodash';
import { getPlatforms, Platform } from '../../models/Platform';

type Props = {
	platforms: Platform[];
};

const Brands: NextPage<Props> = ({ platforms }) => {
	const createCard = (platform: Platform) => {
		return (
			<Link
				href={'#'}
				key={`platform-card-${platform.code}`}
				className="shadow-lg rounded-2xl w-64 m-4 p-4 py-6 bg-white">
				<div className="flex flex-col items-center justify-center">
					<div className="w-24 h-24 rounded-full flex p-1">
						<Image
							src={`/images/platforms/${platform.code}.png`}
							className="object-contain"
							alt={`Plataforma de videojuegos ${platform.name}`}
							title={`Plataforma de videojuegos ${platform.name}`}
							width={88}
							height={88}
							layout="fixed"
						/>
					</div>
					<h2 className="text-gray-800 text-xl font-medium mb-4 mt-4">{platform.name}</h2>
					{/* <h3 className="text-gray-400 text-center text-xs px-2">{station.shortDescription}</h3> */}
				</div>
			</Link>
		);
	};

	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">
					Todas las plataformas de antes y de ahora: consola, pc, etc.
				</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las plataformas para jugar hasta el infinito.
				</h2>
			</div>
			<div className="flex flex-wrap justify-center">
				{platforms.map((platform: Platform) => {
					return createCard(platform);
				})}
			</div>
		</div>
	);
};

export async function getStaticProps() {
	return {
		props: {
			platforms: getPlatforms(),
			title: 'Plataformas'
		}
	};
}

export default Brands;
